module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/hotel-image-tablet-2x-bbc460b6a651e02c2fa848e188984b59.jpg";